<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Equipment' }" tag="li" class="breadcrumb-item">
						<a href="#">裝備</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-12">
						<h3 class="item-title">
							{{ $t("FilterFunction") }}
						</h3>
						<div class="row p-3">
							<input type="text" class="form-control search-btn" :placeholder="$t('FilterEquipment')"
								aria-label="Search for..." v-on:input="debounceInput" />
						</div>
						<div class="row mb-3">
							<div class="col-12">
								<button type="button" class="pcbtn danger m-1" @click="setFilterType(100)">{{
						$t("ClearFilter") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(0)">{{
						$t("Accessories") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(1)">{{ $t("Hat")
									}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(2)">{{
						$t("Shoe")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(3)">{{
						$t("Shield")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(4)">{{
						$t("Clothes")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(5)">{{
						$t("HealStaff") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(6)">{{
						$t("AttackStaff") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(12)">{{
						$t("Axe")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(13)">{{
						$t("Spear")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(15)">{{
						$t("Bow")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(16)">{{
						$t("Glove")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(17)">{{
						$t("Dagger")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(19)">{{
						$t("Knife")
					}}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterType(20)">{{
						$t("Sword")
					}}</button>
								<br />
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(21)">
									{{ $t("physical_critical") }}
								</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(22)">{{
						$t("magic_critical") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(23)">{{
						$t("dodge") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(24)">{{
						$t("accuracy") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(25)">
									{{ $t("energy_reduce_rate") }}
								</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(29)">
									{{ $t("wave_energy_recovery") }}
								</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(30)">
									{{ $t("energy_recovery_rate") }}
								</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(26)">{{
						$t("life_steal") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(27)">{{
						$t("wave_hp_recovery") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(28)">{{
						$t("hp_recovery_rate") }}</button>
								<button type="button" class="pcbtn btnFilter m-1" @click="setFilterProperty(77)">{{
						$t("Level") }}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<h3 class="item-title">
							{{ $t("EquipmentList") }}
						</h3>
						<div v-if="tempBucket.length > 0">
							<div v-for="item in tempBucket">
								{
								"eq_craft": "{{ Number(item.equipment_id) + 10000 }}",
								"eq_id": "{{ item.equipment_id }}",
								"//rank": "{{ item.equipment_name }}"
								},

							</div>
						</div>
						<div class="d-flex flex-wrap justify-content-start">
							<template v-for="item in filterData">
								<div class="itemBox col-4 col-lg-1 col-md-2 p-2 anm-grow">
									<!-- addToBucket -->
									<router-link :to="{ name: 'EquipmentDetail', params: { id: item.equipment_name } }">
										<img class="img-fluid"
											v-lazy="'/static/images/equipment/icon_equipment_' + item.equipment_id + '.png'"
											:alt="getI18nName(item, 'equipment_name')"
											:title="getI18nName(item, 'equipment_name')" />
										<span class="text-center d-block" v-if="filterProperty == 77">
											{{ item.require_level }}
										</span>
									</router-link>
								</div>
								<div v-if="setHr(item.equipment_id)" class="w-100 d-block">
									<hr />
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Equipment",
	data() {
		return {
			filter: "",
			filterType: 100,
			filterRank: "0",
			filterProperty: 100,
			equipmentData: {},
			tempBucket: []
		};
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: "裝備列表",
		// all titles will be injected into this template
		titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
		meta: [{ charset: "utf-8" }, { name: "description", content: "超異域公主連結☆Re:Dive 的裝備列表" }],
	},
	methods: {
		addToBucket: function (item) {
			this.tempBucket.push(item)
		},
		setFilterType: function (type) {
			this.filterType = type;
			this.filterProperty = 100;
			this.filter = "";
		},
		setFilterProperty: function (type) {
			this.filterProperty = type;
			this.filterType = 100;
			this.filter = "";
		},
		getI18nName: function (item, name) {
			switch (this.locale) {
				case "cn":
					return item["cn_" + name];
					break;
				case "en":
					return item["en_" + name];
					break;
				case "jp":
					return item["jp_" + name];
					break;
				default:
					return item[name];
					break;
			}
		},
		setHr: function (item) {
			if (
				item == "150009" ||
				item == "150008" ||
				item == "150007" ||
				item == "150006" ||
				item == "150005" ||
				item == "150004" ||
				item == "150003" ||
				item == "150002" ||
				item == "150001"
			) {
				return true;
			}
		},
		debounceInput: _.debounce(function (e) {
			this.filter = e.target.value;
		}, 500),
	},
	computed: {
		filterData: function () {
			var self = this;
			var ec = self.equipmentData;
			var filterType = this.filterType;
			var filterProperty = this.filterProperty;

			let col = ["設計圖", "碎片", "欠片", "設計図"];
			ec = _.filter(ec, function (o) {
				return !_.some(col, (el) => _.includes(o.equipment_name, el));
			});

			if (self.filter != null) {
				ec = _.filter(ec, function (o) {
					return (
						o.equipment_name.includes(self.filter) ||
						o.jp_equipment_name.includes(self.filter) ||
						o.cn_equipment_name.includes(self.filter) ||
						o.en_equipment_name.includes(self.filter)
					);
				});
			}

			if (filterType != 100) {
				ec = _.filter(ec, function (o) {
					return o.itemType == filterType;
				});
			}

			if (filterProperty != 100) {
				ec = _.filter(ec, function (o) {
					switch (filterProperty) {
						case 21:
							return o.physical_critical > 0;
							break;
						case 22:
							return o.magic_critical > 0;
							break;
						case 23:
							return o.dodge > 0;
							break;
						case 24:
							return o.accuracy > 0;
							break;
						case 25:
							return o.energy_reduce_rate > 0;
							break;
						case 26:
							return o.life_steal > 0;
							break;
						case 27:
							return o.wave_hp_recovery > 0;
							break;
						case 28:
							return o.hp_recovery_rate > 0;
							break;
						case 29:
							return o.wave_energy_recovery > 0;
							break;
						case 30:
							return o.energy_recovery_rate > 0;
							break;
						case 77:
							return o.require_level > 0;
							break;
					}
				});
			}

			ec = _.orderBy(ec, [i => Number(i.promotion_level), "itemType", "require_level", 'equipment_id'], ["desc", "asc", "asc", "desc"]);
			if (filterProperty == 77) {
				ec = _.reverse(
					_.sortBy(ec, function (obj) {
						return parseInt(obj.require_level, 10);
					})
				);
			}
			return ec;
		},
		locale() {
			return this.$i18n.locale;
		},
	},
	created: function () {
		var self = this;
		var itemList = this.$store.getters.getEquipmentData;
		_.forEach(itemList, function (o) {
			try {
				var eer = _.find(self.$store.getters.getEquipmentEnhanceRate, ["equipment_id", o.equipment_id]);
				o.require_level = Number(o.require_level);
				o.equipment_id = Number(o.equipment_id);

				if (_.inRange(Number(o.equipment_id), 10000000, 11000000)) {
					o.itemRank = 10;
				} else if (_.inRange(Number(o.equipment_id), 109000, 110000)) {
					o.itemRank = 9;
				} else if (_.inRange(Number(o.equipment_id), 108000, 109000)) {
					o.itemRank = 8;
				} else if (_.inRange(Number(o.equipment_id), 107000, 108000)) {
					o.itemRank = 7;
				} else if (_.inRange(Number(o.equipment_id), 106000, 107000)) {
					o.itemRank = 6;
				} else if (_.inRange(Number(o.equipment_id), 105000, 106000)) {
					o.itemRank = 5;
				} else if (_.inRange(Number(o.equipment_id), 104000, 105000)) {
					o.itemRank = 4;
				} else if (_.inRange(Number(o.equipment_id), 103000, 104000)) {
					o.itemRank = 3;
				} else if (_.inRange(Number(o.equipment_id), 102000, 103000)) {
					o.itemRank = 2;
				} else if (_.inRange(Number(o.equipment_id), 101000, 102000)) {
					o.itemRank = 1;
				} else {
					o.itemRank = 0;
				}
				if (!eer) {
					return;
				}

				if (_.some(["配件", "命中", "飾品", "アクセサリ"], (el) => _.includes(eer.description, el))) {
					o.itemType = 0;

					return;
				}
				if (_.some(["頭盔", "帽"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 1;
					return;
				}

				if (_.some(["鞋", "靴"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 2;
					return;
				}
				if (eer.description == "盾") {
					o["itemType"] = 3;
					return;
				}
				if (_.some(["魔法服", "衣服", "鎧甲", "鎧", "鎧", "服"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 4;
					return;
				}
				if (_.some(["回復杖", "回復法杖"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 5;
					return;
				}
				if (_.some(["攻撃杖", "攻擊法杖"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 6;
					return;
				}
				if (eer.description == "斧") {
					o["itemType"] = 12;
					return;
				}
				if (_.some(["槍", "戟"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 13;
					return;
				}
				if (eer.description == "弓") {
					if (eer.equipment_id == "105167") {
						o["itemType"] = 13;
						return;
					}
					o["itemType"] = 15;
					return;
				}
				if (_.some(["指虎", "拳"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 16;
					return;
				}
				if (_.some(["短剣", "短劍"], (el) => _.includes(eer.description, el))) {
					o["itemType"] = 17;
					return;
				}
				if (eer.description == "刀") {
					o["itemType"] = 19;
					return;
				}
				if (eer.description == "劍" || eer.description == "剣") {
					o["itemType"] = 20;
					return;
				}
			} catch (e) {
				console.log(e);
			}
		});
		// itemList = _.reverse(
		// 	_.chain(itemList)
		// 		.groupBy("itemRank")
		// 		.map((value, key) => ({ rank: key, items: value }))
		// 		.value()
		// );
		//console.log(_.groupBy(itemList, Math.floor))
		this.equipmentData = itemList;
	},
	mounted: function () {
		$(".btnFilter").on("click", function () {
			$(this)
				.siblings()
				.removeClass("primary");
			$(this).addClass("primary");
		});
		$(".pcbtn.danger").on("click", function () {
			$(".pcbtn").removeClass("primary");
		});
	},
};
</script>
<style scoped>
table {
	table-layout: fixed;
}

.search-btn {
	border-radius: 15px;
	border: 2px solid #fbd173;
}

.pcbtn {
	min-width: 60px;
}
</style>
